import React, { useEffect, useState } from 'react'
import { withStyles, Card, Link } from '@zn-material-ui'
import classNames from 'classnames'
import styles from '../styles/ContentCreation'
import { Homes } from '@services/api'

interface ITask {
  name: string
  path: string
  key: string
  isShow: boolean
  count: string
}

interface IProps {
  classes?: any
  contentCreationArr: ITask[]
}

const ContentCreation = (props: IProps) => {
  const [creationList, setCreationList] = useState<ITask[]>([])
  const { classes, contentCreationArr = [] } = props
  let count = '0'

  const updateCount = () => {
    // 判断当前登录主播是否有直播中直播，用于展示入口小圆点 1：有 0：无
    Homes.checkAnchorLiving().then(({ code, body }) => {
      if (+code === 0) {
        const { isLiving } = body
        count = isLiving !== 0 ? '1' : '0'
      }
      updateCreationList()
    })
  }

  const updateCreationList = () => {
    const operationTask = contentCreationArr.map((item: ITask) => {
      if (item.key === 'live') {
        return { ...item, count }
      }
      return item
    })
    setCreationList(operationTask)
  }

  const renderQuickEntry = (item: ITask) => (
    <Link
      href={item.path}
      key={item.key}
    >
      <div className={classes.iconItem}>
        <span className={classNames(classes.icon, classes[item.key])} />
        {item.count !== '0' && (
          <span className={classes.count} />
        )}
        <span className={classes.cardTitle}>{item.name}</span>
      </div>
    </Link>
  )

  useEffect(() => {
    updateCount()
  }, [])

  return (
    <Card className={classes.card}>
      {/* 内容创作 */}
      <p className={classes.title}>内容创作</p>
      <div className={classes.iconBar}>
        {!!creationList.length && creationList.map((row, index) => (
          <div
            key={index}
            className={classes.entryWrapper}
          >
            {renderQuickEntry(row)}
          </div>
        ))}
      </div>
    </Card>
  )
}

export default withStyles(styles)(ContentCreation)
